import { MapPin, Phone, Mail, Globe } from 'lucide-react';
import { Card, CardContent } from '../ui/Card';
import { cn } from '@/lib/utils';

export interface PublicContactFields {
  name: string;
  address?: string | null;
  phone?: string | null;
  email?: string | null;
  website?: string | null;
}

export function PublicContactFooter({
  entity,
  showMultiLocationPublic = false,
  className,
}: {
  entity: PublicContactFields;
  showMultiLocationPublic?: boolean;
  className?: string;
}) {
  return (
    <footer id="public-contact" className={cn('mt-auto border-t border-border bg-muted/40', className)}>
      <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6 lg:px-8">
        <div className="mb-6 flex flex-wrap justify-center gap-6">
          {!showMultiLocationPublic && entity.address && (
            <Card className="w-full border-border/80 sm:w-[calc(50%-0.75rem)] lg:w-[260px]">
              <CardContent className="p-4 text-center">
                <MapPin className="mx-auto mb-2 h-7 w-7 text-primary-600" aria-hidden />
                <h3 className="mb-1 text-sm font-semibold text-foreground">Address</h3>
                <p className="text-xs text-muted-foreground">{entity.address}</p>
              </CardContent>
            </Card>
          )}

          {entity.phone && (
            <Card className="w-full border-border/80 sm:w-[calc(50%-0.75rem)] lg:w-[260px]">
              <CardContent className="p-4 text-center">
                <Phone className="mx-auto mb-2 h-7 w-7 text-green-600" aria-hidden />
                <h3 className="mb-1 text-sm font-semibold text-foreground">Phone</h3>
                <p className="text-xs text-muted-foreground">{entity.phone}</p>
              </CardContent>
            </Card>
          )}

          {entity.email && (
            <Card className="w-full border-border/80 sm:w-[calc(50%-0.75rem)] lg:w-[260px]">
              <CardContent className="p-4 text-center">
                <Mail className="mx-auto mb-2 h-7 w-7 text-red-600" aria-hidden />
                <h3 className="mb-1 text-sm font-semibold text-foreground">Email</h3>
                <p className="text-xs text-muted-foreground">{entity.email}</p>
              </CardContent>
            </Card>
          )}

          {entity.website && (
            <Card className="w-full border-border/80 sm:w-[calc(50%-0.75rem)] lg:w-[260px]">
              <CardContent className="p-4 text-center">
                <Globe className="mx-auto mb-2 h-7 w-7 text-purple-600" aria-hidden />
                <h3 className="mb-1 text-sm font-semibold text-foreground">Website</h3>
                <a
                  href={entity.website}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="break-all text-xs text-primary-600 hover:underline dark:text-primary-400"
                >
                  Visit website
                </a>
              </CardContent>
            </Card>
          )}
        </div>
        <p className="text-center text-xs text-muted-foreground">
          © {new Date().getFullYear()} {entity.name}
        </p>
      </div>
    </footer>
  );
}
